// Android's Account.isPremium(): SUBSCRIBER (2), LIFETIME (3) or FREE_TRIAL (4).
const PREMIUM_SUBSCRIPTION_TYPES = [2, 3, 4];

export function isPremium (subscriptionType) {
    return PREMIUM_SUBSCRIPTION_TYPES.indexOf(Number(subscriptionType)) !== -1;
}
